export const isActiveStaff = (staff) => {
	const status = staff?.status ? String(staff.status).toLowerCase() : "";
	return status === "active" || staff?.isActive === true;
};

export const mapStaffToOption = (staff) => ({
	id: staff.id,
	name: `${staff.firstName || ""} ${staff.lastName || ""}`.trim() || "Unnamed staff",
});

export const buildTaskStaffFilterOptions = (staffResults) => {
	if (!Array.isArray(staffResults)) {
		return [];
	}

	return staffResults.filter(isActiveStaff).map(mapStaffToOption);
};
